<template>
  <div :class="{ active: shopToast }" class="shop-toast" @click="toggleShopToast()">
    Vous venez d'ajouter un produit à votre panier,
    <router-link class="underline" :to="link">cliquez-ici</router-link> pour le consulter.
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      link: null
    };
  },
  computed: {
    ...mapGetters(["shopToast"])
  },
  methods: {
    toggleShopToast() {
      console.log("clicked");
      this.$store.commit("TOGGLE_SHOP_TOAST");
    },
    setLink() {
      if (window.__osvConf) {
        this.link = window.__osvConf.paths.cartProduct;
      }
    }
  },
  mounted() {
    this.setLink();
    window.addEventListener("OsvCartChange", payload => {
      this.setLink();
    });
  }
};
</script>

<style lang="scss" scoped>
.shop-toast {
  position: fixed;
  bottom: 30px;
  left: 20px;
  right: 20px;
  max-width: 1200px;
  background-color: #43a047;
  transform: translateY(200px);
  transition: transform 0.4s;
  color: white;
  font-weight: bold;
  z-index: 9999999;
  padding: 20px;
  border-radius: 13px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  text-align: center;
  margin: auto;
  line-height: 1.3;
  &.active {
    transform: translateY(0px);
  }
}
</style>
